import React from "react";
import { MdToggleOn, MdToggleOff } from "react-icons/md";
import { PencilLine, Trash2 } from "lucide-react";

export default function TableActionButtons({
    canEdit,
    canDelete,
    canToggle,
    onEdit,
    onDelete,
    onToggle,
    toggleStatus,
}) {
    return (
        <div className="flex items-center gap-2">
            {canEdit && (
                <button
                    type="button"
                    onClick={onEdit}
                    className="inline-flex h-9 w-9 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 shadow-sm transition hover:-translate-y-[1px] hover:border-slate-300 hover:bg-slate-50 hover:text-slate-900"
                    title="Edit"
                    aria-label="Edit"
                >
                    <PencilLine size={16} strokeWidth={1.9} />
                </button>
            )}
            {canToggle && (
                <button type="button" onClick={onToggle} title="Toggle Status" className="transition" aria-label="Toggle status">
                    {toggleStatus === "ACTIVE" ? (
                        <MdToggleOn size={30} className="text-green-500" />
                    ) : (
                        <MdToggleOff size={30} className="text-gray-400" />
                    )}
                </button>
            )}
            {canDelete && (
                <button
                    type="button"
                    onClick={onDelete}
                    className="inline-flex h-9 w-9 items-center justify-center rounded-xl border border-rose-200 bg-rose-50 text-rose-600 shadow-sm transition hover:-translate-y-[1px] hover:border-rose-300 hover:bg-rose-100 hover:text-rose-700"
                    title="Delete"
                    aria-label="Delete"
                >
                    <Trash2 size={16} strokeWidth={1.9} />
                </button>
            )}
        </div>
    );
}
